import BaseModel from './BaseModel';

import CustomLabelId from './CustomLabelId';
import Point from './Point';

export default class CustomLabel extends BaseModel {
  static fields = [
    { key: 'id', type: CustomLabelId, stringify: true },
    { key: 'value', type: 'string', stringify: true },
    { key: 'color', type: 'string', stringify: true },
    { key: 'imgUrl', type: 'string', stringify: true },
    { key: 'offset', type: Point },
    { key: 'visible', type: 'boolean', stringify: true },
  ];
}
